import { ref, type Ref } from 'vue';

interface DraggingState {
  startRow: number;
  startCol: number;
  currentRow: number;
  currentCol: number;
}

interface Emits {
  (e: 'select-cell', row: number, col: number, additive?: boolean, shiftKey?: boolean): void;
  (
    e: 'select-cell-range',
    startRow: number,
    startCol: number,
    endRow: number,
    endCol: number
  ): void;
}

export function useTableCellSelection(isEditable: Ref<boolean>, emit: Emits) {
  const dragging = ref<DraggingState | null>(null);

  const handleCellMouseDown = (row: number, col: number, event: MouseEvent) => {
    if (!isEditable.value) return;

    if (event.shiftKey) {
      emit('select-cell', row, col, false, true);
      return;
    }

    if (event.ctrlKey || event.metaKey) {
      emit('select-cell', row, col, true, false);
    } else {
      emit('select-cell', row, col, false, false);
      dragging.value = { startRow: row, startCol: col, currentRow: row, currentCol: col };
    }
  };

  const handleCellMouseEnter = (row: number, col: number) => {
    if (!dragging.value) return;

    dragging.value.currentRow = row;
    dragging.value.currentCol = col;

    emit('select-cell-range', dragging.value.startRow, dragging.value.startCol, row, col);
  };

  const handleCellSelect = (row: number, col: number) => {
    emit('select-cell', row, col);
  };

  const stopDragging = () => {
    dragging.value = null;
  };

  return {
    dragging,
    handleCellMouseDown,
    handleCellMouseEnter,
    handleCellSelect,
    stopDragging,
  };
}
